import React from 'react';
import DPDropDown from 'framework/components/DPDropDown';
import { Col, Row, Button, Label } from 'reactstrap';



const CustomExcelUploadContent = ({
  ExcelUploadOption,
  selectedExcelOption,
  handleDropdownOnChange,
  disabled,
  handleFileChange,
  fileInputRef,
  handleGenerateExcel
}) => {


  return (
    <React.Fragment>
      <Row className='mb-3'>
        <h4>
          Custom Excel Upload
        </h4>
      </Row>
      <Row>
        <Col sm={12} md={6} className="mb-4-sm">
          <DPDropDown
            rowClass="mb-4-sm"
            labelText="Select Master File"
            textType="text"
            optionGroup={ExcelUploadOption}
            selectedGroup={selectedExcelOption}
            onChange={handleDropdownOnChange}
            disabled={disabled}
          />
        </Col>
        <Col>
          {selectedExcelOption ?
            <Row>
              <Col sm={6} md={4} className="mb-4-sm text-start">
                <Button
                  onClick={handleGenerateExcel}
                  color="success"
                  className="btn-sm"
                  disabled={disabled}
                >
                  Download Template
                </Button>
              </Col>
            </Row>
            : null}
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={6} className="mb-4-sm">
          <Col sm={6} md={6} className="mb-4-sm">
            <Label
              htmlFor="example-text-input"
              className="col-md-4 col-form-label-sm" >
              Select Excel File
            </Label>
          </Col>
          <Col sm={6} md={6} className="mb-6-sm">
            <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} ref={fileInputRef} />
          </Col>
        </Col>
      </Row>

    </React.Fragment>
  );
};



export default CustomExcelUploadContent;
